import { Pipe } from '@angular/core';
import { normalizeDate } from '@kp/utils';
import { differenceInCalendarDays } from 'date-fns';

import type { PipeTransform } from '@angular/core';
import type { TiiaModel, TravelDestination } from '@kp/interfaces';

@Pipe({ name: 'kpShowCar' })
class ShowCarPipe implements PipeTransform {
  transform({
    additionalAgreementInfo: { destination },
    endDate,
    temp: { beginDate },
  }: TiiaModel): boolean {
    return isCarInterestAvailable(destination, beginDate, endDate);
  }
}

/**
 * Return whether is car interest available for customer
 */
function isCarInterestAvailable(
  destination: TravelDestination,
  beginDate?: string,
  endDate?: string,
): boolean {
  return (
    (destination === 'C' || destination === 'E') &&
    differenceInCalendarDays(normalizeDate(endDate), normalizeDate(beginDate)) +
      1 <=
      30
  );
}

export { isCarInterestAvailable, ShowCarPipe };
